(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  
    
  window.addEventListener('scroll',(event) => {
    if (!!document.querySelector(".recommendations .silder-product .splide__arrows") === false){
      var splide = new Splide( '.recommendations .silder-product .splide', {
          type: 'loop',
          autoplay: true,
          autoWidth:true,
          interval: 5000,
          pauseOnHover: true,
          speed: 1200,
          perPage: 1,
          direction: 'ltr',
          focus: 'left',
          gap: '30px',
          pagination: false,
          drag: false,
          breakpoints: {
            767: {
              focus: 'center',
              gap: '15px',
              drag: true,
            },
          },
      } );
      splide.mount();
      
      document.querySelector(".recommendations .slider-arrows .left-arrow").onclick = function() {
          document.querySelector(".recommendations .splide__arrows .splide__arrow--prev").click();
      };
      
      document.querySelector(".recommendations .slider-arrows .right-arrow").onclick = function() {
          document.querySelector(".recommendations .splide__arrows .splide__arrow--next").click();
      };
    }
  });

  } catch(e) { console.error(e); }
})();
})();
